export default __webpack_public_path__ + "static/media/logo_landing_page.f5fff5cc.svg";